module.exports = "https://coursera_assets.s3.amazonaws.com/images/d82b08e0d84ae3ae7a1321a0415e22c0.svg";